module.exports = __webpack_public_path__ + "media/images/home-banners/torrent-3119822_1920-702b321df8bdf41a0ebc010f4601cc9e.jpg";